import { createReducer, on } from '@ngrx/store';

import {
    IRespPreRegister,
    IResultCounters,
    IResultCountersSave,
    ISuccesfull,
    Users,
} from '../../shared/models/ApplicationUser';
import { TenderoLogin } from '../../shared/models/TenderoLogin.interface';
import {
    ChangePass,
    clearChangePass,
    clearCounters,
    clearCountersSave,
    clearLoginTelPass,
    clearPhoneVaidationPass,
    clearPreRegisterUser,
    clearRefreshAuthToken,
    clearRegisterUser,
    clearSendCodeVerify,
    clearSendSmsPhone,
    clearUpdatedUserData,
    Counters,
    CountersSave,
    errorChangePass,
    errorCounters,
    errorCountersSave,
    errorLoginTelPass,
    errorPhoneVaidationPass,
    errorPreRegisterUser,
    errorRefreshAuthToken,
    errorRegisterUser,
    errorSendCodeVerify,
    errorSendSmsPhone,
    errorUpdatedUserData,
    loginTelPass,
    phoneVaidationPass,
    preRegisterUser,
    RefreshAuthToken,
    registerUser,
    SendCodeVerify,
    SendSmsPhone,
    setCounter,
    successChangePass,
    successCounters,
    successCountersSave,
    successLoginTelPass,
    successPhoneVaidationPass,
    successPreRegisterUser,
    successRefreshAuthToken,
    successRegisterUser,
    successSendCodeVerify,
    successSendSmsPhone,
    successUpdatedUserData,
    updatedUserData,
} from '../actions';

interface IGeneric {
    error: any;
    failed: boolean;
    success: boolean;
    loading: boolean;
}

/**
 * * Baja los datos actualizados del usuario
 */
export interface UpdatedState extends IGeneric {
    data: Users;
}

export const UpdatedInit: UpdatedState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as Users,
};

const _updatedUserReducer = createReducer(
    UpdatedInit,
    on(updatedUserData, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successUpdatedUserData, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorUpdatedUserData, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearUpdatedUserData, state => ({ ...state, ...UpdatedInit })),
);

export function UpdatedUserReducer(state: any, action: any) {
    return _updatedUserReducer(state, action);
}

/**
 * * Realiza el login del usuario
 */
export interface LoginTelPassState extends IGeneric {
    data: TenderoLogin;
    error: any;
}

export const LoginTelPassInit: LoginTelPassState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as TenderoLogin,
};

const _loginTelPassReducer = createReducer(
    LoginTelPassInit,
    on(loginTelPass, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successLoginTelPass, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorLoginTelPass, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearLoginTelPass, state => ({ ...state, ...LoginTelPassInit })),
);

export function LoginTelPassReducer(state: any, action: any) {
    return _loginTelPassReducer(state, action);
}

/**
 * * Realiza el registro del usuario
 */
export interface RegisterUserState extends IGeneric {
    data: ISuccesfull;
}

export const RegisterUserInit: RegisterUserState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as ISuccesfull,
};

const _registerUserReducer = createReducer(
    RegisterUserInit,
    on(registerUser, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successRegisterUser, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorRegisterUser, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearRegisterUser, state => ({ ...state, ...RegisterUserInit })),
);

export function RegisterUserReducer(state: any, action: any) {
    return _registerUserReducer(state, action);
}


/**
 * * Realiza validacion inicial del usuario
 */
export interface PreRegisterUserState extends IGeneric {
    data: IRespPreRegister;
}

export const PreRegisterUserInit: PreRegisterUserState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as IRespPreRegister,
};

const _prePegisterUserReducer = createReducer(
    PreRegisterUserInit,
    on(preRegisterUser, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successPreRegisterUser, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorPreRegisterUser, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearPreRegisterUser, state => ({ ...state, ...PreRegisterUserInit })),
);

export function PreRegisterUserReducer(state: any, action: any) {
    return _prePegisterUserReducer(state, action);
}

/**
 * * Realiza validacion telfono cambio contraseña
 */
export const PhoneValidInit: RegisterUserState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as ISuccesfull,
};

const _phoneValidReducer = createReducer(
    PhoneValidInit,
    on(phoneVaidationPass, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successPhoneVaidationPass, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorPhoneVaidationPass, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearPhoneVaidationPass, state => ({ ...state, ...PhoneValidInit })),
);

export function PhoneValidReducer(state: any, action: any) {
    return _phoneValidReducer(state, action);
}

/**
 * * Realiza cambio contraseña
 */
export const ChangePassInit: RegisterUserState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as ISuccesfull,
};

const _changePassReducer = createReducer(
    ChangePassInit,
    on(ChangePass, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successChangePass, (state, data) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorChangePass, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearChangePass, state => ({ ...state, ...ChangePassInit })),
);

export function ChangePassReducer(state: any, action: any) {
    return _changePassReducer(state, action);
}


/**
 * * Obtiene los contadores por dispositivo
 */
export interface CountersState extends IGeneric {
    data: IResultCounters[];
}

export const CountersInit: CountersState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: [
        {
            ID_Flujo: 1,
            Llave: 'SMS',
            ExcedeLimite: false,
            UltimoRegistro: null,
            CantidadRegistros: 0
        },
        {
            ID_Flujo: 2,
            Llave: 'Reseteo',
            ExcedeLimite: false,
            UltimoRegistro: null,
            CantidadRegistros: 0
        }
    ],
};

const _countersReducer = createReducer(
    CountersInit,
    on(Counters, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successCounters, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(setCounter, (state, { ID_Flujo, ExcedeLimite, UltimoRegistro }) => (
        {
            ...state,
            loading: false,
            success: true,
            data: state.data.map(c => c.ID_Flujo === ID_Flujo ? ({ ...c, CantidadRegistros: c.CantidadRegistros + 1, ExcedeLimite, UltimoRegistro }) : c),
        }
    )),
    on(errorCounters, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearCounters, state => ({ ...state, ...CountersInit })),
);

export function CountersReducer(state: any, action: any) {
    return _countersReducer(state, action);
}

/**
 * * Guarda contador por dispositivo
 */
export interface CountersSaveState extends IGeneric {
    data: IResultCountersSave;
    ID_Flujo: number;
}

export const CountersSaveInit: CountersSaveState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    ID_Flujo: 0,
    data: {} as IResultCountersSave,
};

const _countersSaveReducer = createReducer(
    CountersSaveInit,
    on(CountersSave, (state, { flowId }) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
            ID_Flujo: flowId,
        }
    )),
    on(successCountersSave, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorCountersSave, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearCountersSave, state => ({ ...state, ...CountersSaveInit })),
);

export function CountersSaveReducer(state: any, action: any) {
    return _countersSaveReducer(state, action);
}

/**
 * * Envio de verficacion de sms
 */
export interface SendSmsPhoneState extends IGeneric {
    data: {
        Codigo: string;
    };
}
export const SendSmsPhoneInit: SendSmsPhoneState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {
        Codigo: ''
    },
};

const _sendSmsPhoneReducer = createReducer(
    SendSmsPhoneInit,
    on(SendSmsPhone, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successSendSmsPhone, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorSendSmsPhone, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearSendSmsPhone, state => ({ ...state, ...SendSmsPhoneInit })),
);

export function SendSmsPhoneReducer(state: any, action: any) {
    return _sendSmsPhoneReducer(state, action);
}

/**
 * * Envio de verficacion de codigo de verificacion
 */
export interface SendCodeVerifyState extends IGeneric {
    data: {
        Actualizado: number;
    };
}
export const SendCodeVerifyInit: SendCodeVerifyState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {
        Actualizado: 0
    },
};

const _sendCodeVerifyReducer = createReducer(
    SendCodeVerifyInit,
    on(SendCodeVerify, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successSendCodeVerify, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorSendCodeVerify, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearSendCodeVerify, state => ({ ...state, ...SendCodeVerifyInit })),
);

export function SendCodeVerifyReducer(state: any, action: any) {
    return _sendCodeVerifyReducer(state, action);
}


/**
 * * Realiza el refresh auth token
 */
export interface RefreshAuthTokenState extends IGeneric {
    token: string;
}

export const RefreshAuthTokenInit: RefreshAuthTokenState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    token: '',
};

const _refreshAuthTokenReducer = createReducer(
    RefreshAuthTokenInit,
    on(RefreshAuthToken, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successRefreshAuthToken, (state, { authToken }) => (
        {
            ...state,
            loading: false,
            success: true,
            token: authToken,
        }
    )),
    on(errorRefreshAuthToken, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearRefreshAuthToken, state => ({ ...state, ...RefreshAuthTokenInit })),
);

export function RefreshAuthTokenReducer(state: any, action: any) {
    return _refreshAuthTokenReducer(state, action);
}